import React, { useState, useEffect, useRef } from "react";
import StripeSvg from '../svgs/StripeSvg';
import { numberWithCommas } from '../utils/util';
import { server_ip } from "../config";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { validateuserId } from "../services/users";
import TdollarSvg from '../svgs/TDollarSvg'

const TOPUP_PLANS=[
    {_id:'6877428d8067fd1021bfd53b',name: '100 T.Dollar', price: 100,topup:100},
    {_id:'6877491d8067fd1021bfd53e',name: '300 T.Dollar', price: 300, topup:300},
    {_id:'687749398067fd1021bfd53f',name: '500 T.Dollar', price: 500, topup:500},
    {_id:'687749518067fd1021bfd540',name: '1000 T.Dollar', price: 1000, topup:1000},
]
export default function TopUpPage(props) {
    const [quantity, setquantity] = useState(1)
    const [searchParams, setSearchParams] = useSearchParams();
    const userId = searchParams.get('userid') || null;
    const [isUserValid, setIsUserValid] = useState(false);

    // function total() { return quantity * (data?.price || 0) }
    function add() { setquantity(s => s + 1) }
    function minus() { setquantity(s => s - 1 < 1 ? 1 : s - 1) }
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => { navigate(str) }
    let { id } = useParams()
    // const [data, setData] = useState({})


    async function validUserId(userId) {
        let result = await validateuserId(userId)
        setIsUserValid(result?.result || false)
    }
    useEffect(() => {
        if (userId && userId.length === 24) {
            validUserId(userId)
        }
    }, [userId])

    const [selectedPlan, setSelectedPlan] = useState(null);


    const handleSubmit = async (event) => {
        event.preventDefault()
        if(!TOPUP_PLANS?.[selectedPlan]){
            alert('請選擇充值金額')
            return
        }
        const formData = new FormData(event.target);

        // Add custom attributes to the form data
        formData.append('jwt', props.token?.token || 'null');
        formData.append('userid', userId || '');
        formData.append('products', JSON.stringify([
            { name: TOPUP_PLANS?.[selectedPlan]?.name || 'No item name', productId: TOPUP_PLANS?.[selectedPlan]?._id, quantity:1 },
        ]));

        // Create a new FormData object with modified data
        const modifiedFormData = formData; // You can modify this as needed

        // Create a new form element
        const newForm = document.createElement('form');
        newForm.action = event.target.action; // Keep the original form action
        newForm.method = 'post';

        // Append each field to the new form
        for (let pair of modifiedFormData.entries()) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = pair[0];
            input.value = pair[1];
            newForm.appendChild(input);
        }

        // Append the new form to the document body and submit it
        document.body.appendChild(newForm);

        newForm.submit()
    }


    if ((!isUserValid) || (!userId)) {
        return (
            <div className="w-full flex flex-col items-center justify-start p-[16px] bg-[#ddd] flex-1">
                <div className="max-w-[600px] w-[100%] mt-[64px] font-bold text-[24px]">
                    您的帳號尚未登入
                </div>
                <div className="max-w-[600px] w-[100%] mt-[64px] font-bold text-[16px]">
                    請先登入或註冊帳號
                </div>
            </div>
        )
    }
    return (
        <div className="w-full flex flex-col items-center justify-start p-[16px] bg-[#ddd] flex-1">
            <div className="max-w-[600px] w-[100%] flex flex-col items-center p-[16px]">
                <div className="mt-[64px] font-bold text-[24px] text-[#6E604C]">T.Dollar充值金額</div>
                <div className="flex flex-row items-center justify-between w-full mt-[64px] flex-wrap gap-[8px] cursor-pointer">
                    {TOPUP_PLANS?.map((item,index)=>
                        <div key={index} onClick={()=>{setSelectedPlan(index)}} className="relative rounded-[8px] flex flex-col items-center justify-center gap-[4spx]" style={{flex:1,minWidth:'max(45%, 170px)',height:undefined,aspectRatio:1,border:selectedPlan===index?'2px solid #7D7649':'2px solid white'}}>
                            <div className="inset-0 absolute" style={{background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.3) 28.5%, #FFFFFF 100%)'}}/>
                            <div className="flex flex-row gap-[16px] items-center justify-center text-[44px] text-[#6E604C] font-bold z-[2]">
                                <TdollarSvg/>
                                {numberWithCommas(item?.topup)}
                            </div>
                            <div className="text-[#6E604C] text-[24px] font-[400] z-[2]">HK${numberWithCommas(item?.price)}</div>
                            <div className="px-[24px] rounded-[99px] py-[4px] text-[white] mt-[10%] hover:opacity-[.5] z-[2]" style={{background: selectedPlan===index?'linear-gradient(180deg, #244258 0%, #0D6C7B 100%)':'linear-gradient(180deg, #8C866B 0%, rgba(143, 137, 109, 0.96) 14%, rgba(153, 146, 116, 0.84) 32%, rgba(169, 160, 127, 0.8) 53%, rgba(153, 146, 116, 0.4) 100%)'}}>
                                選擇
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="w-full h-[1px] bg-[#00000026]"/>
            <div className="max-w-[600px] w-[100%] flex flex-row justify-between items-center p-[16px]">
                <div className="text-[#425457] text-[16px] font-[600]">總額</div>
                <div className="font-bold text-black text-[28px]">HK${TOPUP_PLANS?.[selectedPlan]?.price||0}</div>
            </div>
            <div className="w-full h-[1px] bg-[#00000026]"/>
            <div className="max-w-[600px] w-[100%] flex flex-row items-center justify-end p-[16px] gap-[8px]">
                <TdollarSvg/>
                <div className="text-[#0F737E] text-[28px] font-bold">+{TOPUP_PLANS?.[selectedPlan]?.topup||0}</div>
            </div>
            <form action={`${server_ip}/api/stripe/create-checkout-session`} className="max-w-[600px] w-[100%] my-[64px]" method="POST" onSubmit={handleSubmit}>
                <button type="submit" className="w-full flex flex-col items-center justify-center p-[16px] cursor-pointer hover:opacity-[.5]">
                    <PaymentButton width='100%'/>
                </button>
            </form>
        </div>
    );
} 



const PaymentButton = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 398}
      height={undefined}
      aspectRatio={398*53}
      viewBox="0 0 398 53"
      fill="none"
      {...props}
    >
     
      <rect
        width={397}
        height={52}
        x={0.5}
        y={0.5}
        fill="url(#bpayment)"
        stroke="url(#cpayment)"
        data-figma-bg-blur-radius={4}
        rx={26}
      />
      <path
        fill="#fff"
        d="M153.49 25.08h1.96v6.66c0 .347.053.567.16.66.107.093.353.14.74.14h2.5c.253 0 .44-.073.56-.22.133-.147.227-.447.28-.9.053-.453.093-1.127.12-2.02.147.12.32.233.52.34.213.093.427.18.64.26.227.067.42.127.58.18-.067 1.067-.187 1.9-.36 2.5-.16.587-.413 1-.76 1.24-.333.24-.813.36-1.44.36h-2.9c-.667 0-1.193-.08-1.58-.24a1.397 1.397 0 0 1-.8-.78c-.147-.373-.22-.873-.22-1.5v-6.68Zm-4.58.16h1.96a24.202 24.202 0 0 1-.42 3.18 8.547 8.547 0 0 1-.98 2.62c-.44.773-1.073 1.453-1.9 2.04-.813.587-1.88 1.087-3.2 1.5a3.31 3.31 0 0 0-.3-.54c-.12-.2-.253-.4-.4-.6a3.722 3.722 0 0 0-.42-.46c1.2-.333 2.16-.74 2.88-1.22.72-.48 1.267-1.04 1.64-1.68.387-.64.653-1.36.8-2.16.16-.813.273-1.707.34-2.68Zm5.02-3.46 1.56-.88a26.17 26.17 0 0 1 1.8 1.58 26 26 0 0 1 1.7 1.74c.533.573.96 1.1 1.28 1.58l-1.7 1.04c-.28-.48-.68-1.013-1.2-1.6-.507-.6-1.06-1.2-1.66-1.8-.6-.6-1.193-1.153-1.78-1.66Zm-10.42-3.06h17.46v1.8h-17.46v-1.8Zm1.72 7.64a20.794 20.794 0 0 0-.44-1.28 7.195 7.195 0 0 0-.24-.66c.267-.067.533-.22.8-.46.267-.253.58-.587.94-1 .187-.2.46-.52.82-.96.36-.453.76-.993 1.2-1.62a39.5 39.5 0 0 0 1.36-2.06c.467-.733.887-1.473 1.26-2.22l2.16.68a41.901 41.901 0 0 1-2.06 3.18 42.474 42.474 0 0 1-2.22 2.9c-.747.893-1.48 1.7-2.2 2.42v.06l-.22.1c-.133.067-.293.153-.48.26a4.46 4.46 0 0 0-.48.34c-.133.12-.2.227-.2.32Zm0 0-.02-1.46 1.28-.66 11.74-.46.14.88c.067.32.127.58.18.78l-4.82.24a462.82 462.82 0 0 0-3.42.18c-.92.053-1.68.1-2.28.14-.6.04-1.08.08-1.44.12-.36.027-.64.06-.84.1-.2.04-.373.087-.52.14Zm23.64-8.3h12.08v1.64h-12.08v-1.64Zm-.88 14.52h13.48v1.62h-13.48v-1.62Zm1.84-11.22h9.96v11.6h-1.74V22.8h-6.52v10.16h-1.7v-11.6Zm1.22 2.86h7.36v1.36h-7.36v-1.36Zm-.04 2.8h7.8v1.32h-7.8v-1.32Zm-.02 2.78h7.46v1.36h-7.46V29.8Zm3.1-13.66 2 .08a45.588 45.588 0 0 1-.38 2.06c-.133.707-.28 1.387-.44 2.04-.147.64-.293 1.2-.44 1.68l-1.64-.16c.12-.507.24-1.093.36-1.76s.227-1.347.32-2.04c.107-.693.18-1.327.22-1.9Zm-6.82.02 1.74.54a35.038 35.038 0 0 1-1.44 3.38 30.446 30.446 0 0 1-1.8 3.16c-.64.987-1.3 1.86-1.98 2.62a4.314 4.314 0 0 0-.28-.58c-.12-.253-.247-.5-.38-.74a4.957 4.957 0 0 0-.36-.6c.6-.64 1.173-1.373 1.72-2.2.56-.84 1.08-1.733 1.56-2.68.48-.947.887-1.913 1.22-2.9Zm-2.04 5.38 1.74-1.8.02.02v14.92h-1.76V21.54ZM187.15 33V20.22h-4.3v-1.96h10.98v1.96h-4.32V33h-2.36Zm7.747.28c-.426 0-.793-.153-1.1-.46-.293-.32-.44-.713-.44-1.18 0-.48.147-.867.44-1.16.307-.307.674-.46 1.1-.46.44 0 .807.153 1.1.46.307.293.46.68.46 1.16 0 .467-.153.86-.46 1.18-.293.307-.66.46-1.1.46Zm4.918-.28V18.26h3.82c1.52 0 2.806.28 3.86.84a5.452 5.452 0 0 1 2.4 2.44c.56 1.08.84 2.427.84 4.04 0 1.6-.28 2.953-.84 4.06-.547 1.107-1.34 1.947-2.38 2.52-1.04.56-2.294.84-3.76.84h-3.94Zm2.32-1.9h1.34c1.053 0 1.94-.207 2.66-.62.733-.413 1.28-1.027 1.64-1.84.373-.827.56-1.847.56-3.06 0-1.227-.187-2.24-.56-3.04-.36-.8-.907-1.393-1.64-1.78-.72-.4-1.607-.6-2.66-.6h-1.34V31.1Zm15.884 2.18a5.11 5.11 0 0 1-2.56-.68c-.787-.467-1.427-1.127-1.92-1.98-.48-.867-.72-1.907-.72-3.12 0-1.227.24-2.267.72-3.12.493-.867 1.133-1.527 1.92-1.98a5.11 5.11 0 0 1 2.56-.68c.667 0 1.313.133 1.94.4.627.253 1.18.627 1.66 1.12.48.493.86 1.1 1.14 1.82.28.707.42 1.52.42 2.44 0 1.213-.247 2.253-.74 3.12-.48.853-1.113 1.513-1.9 1.98a4.894 4.894 0 0 1-2.52.68Zm0-1.92c.573 0 1.067-.16 1.48-.48.427-.32.753-.767.98-1.34.227-.587.34-1.267.34-2.04 0-.773-.113-1.447-.34-2.02-.227-.587-.553-1.04-.98-1.36-.413-.333-.907-.5-1.48-.5-.587 0-1.093.167-1.52.5-.413.32-.733.773-.96 1.36-.227.573-.34 1.247-.34 2.02 0 .773.113 1.453.34 2.04.227.573.547 1.02.96 1.34.427.32.933.48 1.52.48Zm10.165 1.92c-.56 0-1.007-.113-1.34-.34a1.982 1.982 0 0 1-.72-1c-.147-.44-.22-.953-.22-1.54V17.06h2.3v13.46c0 .307.053.527.16.66.12.12.246.18.38.18h.16c.053-.013.133-.027.24-.04l.28 1.74c-.134.053-.3.1-.5.14-.2.053-.447.08-.74.08Zm5.957 0c-.56 0-1.007-.113-1.34-.34a1.982 1.982 0 0 1-.72-1c-.147-.44-.22-.953-.22-1.54V17.06h2.3v13.46c0 .307.053.527.16.66.12.12.246.18.38.18h.16c.053-.013.133-.027.24-.04l.28 1.74c-.134.053-.3.1-.5.14-.2.053-.447.08-.74.08Zm6.277 0c-.627 0-1.187-.133-1.68-.4-.48-.267-.86-.64-1.14-1.12-.28-.48-.42-1.04-.42-1.68 0-1.187.52-2.1 1.56-2.74 1.053-.653 2.726-1.107 5.02-1.36a4.146 4.146 0 0 0-.2-1.18 1.662 1.662 0 0 0-.64-.86c-.294-.227-.714-.34-1.26-.34-.574 0-1.127.113-1.66.34a11.61 11.61 0 0 0-1.52.78l-.86-1.56c.386-.24.813-.467 1.28-.68a7.658 7.658 0 0 1 1.5-.54 6.225 6.225 0 0 1 1.66-.22c.92 0 1.673.187 2.26.56.586.36 1.02.887 1.3 1.58.293.693.44 1.533.44 2.52V33h-1.88l-.18-1.26h-.08a8.495 8.495 0 0 1-1.62 1.1 4.15 4.15 0 0 1-1.88.44Zm.7-1.84c.48 0 .926-.107 1.34-.32.413-.227.846-.553 1.3-.98v-2.68c-1.08.12-1.94.3-2.58.54-.64.227-1.1.5-1.38.82-.267.307-.4.667-.4 1.08 0 .547.166.94.5 1.18.333.24.74.36 1.22.36Zm8.204 1.56V21.98h1.88l.2 1.98h.04c.4-.707.873-1.253 1.42-1.64.546-.4 1.12-.6 1.72-.6.266 0 .493.02.68.06.186.04.366.093.54.16l-.4 2.02c-.2-.067-.38-.113-.54-.14a3.595 3.595 0 0 0-.58-.04c-.44 0-.907.18-1.4.54-.494.347-.914.96-1.26 1.84V33h-2.3Z"
      />
      <defs>
        <linearGradient
          id="bpayment"
          x1={199}
          x2={199}
          y1={0}
          y2={53}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8C866B" />
          <stop offset={0.14} stopColor="#8F896D" stopOpacity={0.96} />
          <stop offset={0.32} stopColor="#999274" stopOpacity={0.84} />
          <stop offset={0.53} stopColor="#A9A07F" stopOpacity={0.8} />
          <stop offset={1} stopColor="#999274" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="cpayment"
          x1={16.357}
          x2={146.136}
          y1={22.508}
          y2={206.122}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDCFA2" />
          <stop offset={0.08} stopColor="#8C866B" />
          <stop offset={0.26} stopColor="#8C866A" />
          <stop offset={0.45} stopColor="#F5E6B6" />
          <stop offset={0.59} stopColor="#7D7649" />
          <stop offset={0.84} stopColor="#8C866B" />
          <stop offset={1} stopColor="#A59A87" />
        </linearGradient>
      </defs>
    </svg>
  )